export default __webpack_public_path__ + "static/media/IconDesc_ConversionCube.64.c8242479.png";